import React from 'react';
import { Redirect } from 'react-router-dom';

export default function Initial({ config, location, history }) {
  return <Redirect to="/identity/verify" noThrow />;
}
